// libs
import { styled } from '@nykaa/ui-components';
import { HIDE_SCROLLBARS } from 'shared/styles/base';

export const SizeChartStripContainer = styled.div<{
  isBottomSheet: boolean;
  isDesktopWishlist?: boolean;
}>`
  ${HIDE_SCROLLBARS}
  ${({ theme }) => `
   width: calc(100vw - 1rem);
   padding-bottom: ${theme.spacing.spacing20};
   padding-right: ${theme.spacing.spacing80};
 `};
  overflow: auto;
  min-width: ${({ isBottomSheet, isDesktopWishlist }) =>
    isBottomSheet && !isDesktopWishlist
      ? `calc(100vw - 1rem)`
      : isDesktopWishlist
      ? `auto`
      : `inherit`};
`;

export const StripContent = styled.div`
  ${({ theme }) => `
   padding: ${theme.spacing.spacing40} ${theme.spacing.spacing80} ${theme.spacing.spacing40} 0;
   color: ${theme.colors.textPrimary};
   margin-top: ${theme.spacing.spacing80};
   border-radius: 0 ${theme.spacing.spacing100} ${theme.spacing.spacing100} 0;
 `};
  background: linear-gradient(90deg, rgba(243, 244, 245, 0) -7.14%, #f0f7ff 100%);
  ${({ theme }) => theme.typography.type120};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  white-space: nowrap;
  width: fit-content;
`;

export const Dot = styled.i`
  height: 4px;
  width: 4px;
  ${({ theme }) => `background-color: ${theme.colors.textDisabled};
  margin: 0 ${theme.spacing.spacing40};
  border-radius: ${theme.borders.radiusFull};`};
  display: inline-flex;
  top: -2px;
  position: relative;
`;
